export const FETCH_ALL_USER = 'fetch_all_user';
export const FETCH_ALL_USER_SUCCESS = 'fetch_all_user_success';
export const EDIT_USER = 'edit_user';
export const DELETE_USER = 'delete_user';
export const CREATE_USER = 'create_user';
export const CREATE_USER_SUCCESS = 'create_user_success';
export const UPDATE_USER_SUCCESS = 'update_user_success';
export const UPDATE_USER = 'update_user';
export const DELETE_USER_SUCCESS = 'delete_user_success';
export const SET_USER = 'set_user';
export const SET_ROLE = 'set_role';
export const VERIFY_EMAIL = 'verify_email';
export const VERIFY_EMAIL_SUCCESS = 'verify_email_success';
export const SET_PASSWORD = 'set_password';
export const SET_PASSWORD_SUCCESS = 'set_password_success';
export const FORGOT_PASSWORD = 'forgot_password';